export default "__VITE_ASSET__35t9TbD3__"